import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=2a0d6da0&"
import script from "./NewsletterModal.vue?vue&type=script&lang=ts&"
export * from "./NewsletterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports